import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from '../lib/toast';
import { resendVerification } from '../services/api';
import './ResendVerification.css';

const ResendVerification = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const prefilledEmail = location.state?.email || '';
  const [email, setEmail] = useState(prefilledEmail);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error(t('auth.verification.emailRequired', 'Email is required'));
      return;
      return;
    }
    setLoading(true);
    try {
      const { data } = await resendVerification(email.trim());
      setSent(true);
      toast.success(data.message || t('auth.verification.emailSent', 'Email Sent!'));
    } catch (err) {
      toast.error(err.response?.data?.error || t('auth.verification.resendFailed', 'Failed to resend verification email'));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="resend-verification-page fade-in">
        <div className="resend-container">
          <div className="success-message">
            <div className="success-icon">📧</div>
            <h2>{t('auth.verification.emailSent', 'Email Sent!')}</h2>
            <p>{t('auth.verification.checkInbox', 'Please check your inbox and click the verification link.')}</p>
            <p className="email-display">{email}</p>
            <button type="button" onClick={() => setSent(false)} className="btn btn-secondary btn-lg">
              {t('auth.verification.resendAgain', 'Resend Again')}
            </button>
            <Link to="/login" className="resend-back-link">{t('auth.verification.backToLogin', 'Back to sign in')}</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="resend-verification-page fade-in">
      <div className="resend-container">
        <h2>{t('auth.verification.resendTitle', 'Resend Verification Email')}</h2>
        <p className="subtitle">{t('auth.verification.resendSubtitle', 'Enter your email to receive a new verification link')}</p>
        <form onSubmit={handleSubmit} className="resend-form">
          <div className="form-group">
            <label htmlFor="resend-email">{t('auth.login.emailLabel', 'Email address')}</label>
            <input
              id="resend-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              disabled={loading}
              className="form-input"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-lg w-full" disabled={loading}>
            {loading ? t('common.sending', 'Sending...') : t('auth.verification.sendEmail', 'Send Verification Email')}
          </button>
        </form>
        <p className="resend-footer">
          <Link to="/login">{t('auth.verification.backToLogin', 'Back to sign in')}</Link>
        </p>
      </div>
    </div>
  );
};

export default ResendVerification;
